<ion-grid style="padding: 0;">
    <ion-row style="padding: 0;" class="my-navbar">
        <ion-col size="8" class="my-navbar-left">
            <div class="nav-icon logo">
                <img src="assets/img/isotipo-trainingym.svg" alt="logo" (click) = "goTo('/schedule')" />
            </div>
            <div class="nav-icon menu" (click)="toggleMenu()">
                <img src="assets/icons/menu.svg" alt="menu" />
            </div>
            <div class="nav-icon forward" [class.hidden-item] = "!urlHistory.length" (click) = "goBackUrl()">
                <img src="assets/icons/left.svg" alt="forward" />
            </div>
        </ion-col>
        <ion-col size="2"></ion-col>
        <ion-col size="1" class="my-navbar-right">
            <ion-button fill="clear" size="default" color="dark" id="right-menu-trigger"><ion-icon name="ellipsis-horizontal-outline"></ion-icon></ion-button>
        </ion-col>
    </ion-row>
</ion-grid>

<ion-list *ngIf="showMenu" class="menu-list">
    <ion-item
        (click)="goTo('/kpi')"
        [class.selected]="currentUrl === '/kpi'"
        [disabled] = "currentUrl === '/kpi'"
        *ngIf = "displayedItems.kpis">
        <ion-label><img src="assets/icons/global-outline-icon.svg" alt="menu" /> {{ 'business_kpis' | translate }}</ion-label>
    </ion-item>

    <ion-item
        (click)="goTo('/schedule')"
        [class.selected]="currentUrl === '/schedule'"
        [disabled] = "currentUrl === '/schedule'"
        *ngIf = "displayedItems.schedules">
        <ion-label><img src="assets/icons/my_schedule.svg" alt="menu" /> {{ 'feature_schedule' | translate }}</ion-label>
    </ion-item>

    <ion-item
        (click)="toggleShowMembers()"
        [class.selected]="currentUrl === '/capacity'"
        [disabled] = "currentUrl === '/capacity'"
        class="has-submenu"
        *ngIf = "displayedItems.membersControl.displayMembers">
        <ion-label><img src="assets/icons/team.svg" alt="menu" /> {{ 'members' | translate }}</ion-label>
    </ion-item>

    <ng-container *ngIf="showMembers">
        <ion-item
            (click)="goTo('/members/active')"
            [class.selected]="currentUrl === '/members/active'"
            [disabled] = "currentUrl === '/members/active'"
            class="submenu"
            *ngIf="displayedItems.membersControl.membersActive">
            <ion-label>{{ 'socios_activos' | translate }}</ion-label>
        </ion-item>

        <!-- TODO: Uncomment for potential member development
        <ion-item
            (click)="goTo('/members/potential')"
            [class.selected]="currentUrl === '/members/potential'"
            [disabled] = "currentUrl === '/members/potential'"
            class="submenu"
            *ngIf="displayedItems.membersControl.membersPotential">
            <ion-label>{{ 'socios_potenciales' | translate }}</ion-label>
        </ion-item>

        <ion-item
            (click)="goTo('/members/canceled')"
            [class.selected]="currentUrl === '/members/canceled'"
            [disabled] = "currentUrl === '/members/canceled'"
            class="submenu"
            *ngIf="displayedItems.membersControl.membersCanceled">
            <ion-label>{{ 'socios_baja' | translate }}</ion-label>
        </ion-item>
        -->
    </ng-container>

    <ion-item
        (click)="goTo('/activities')"
        [class.selected]="currentUrl === '/activities'"
        [disabled] = "currentUrl === '/activities'"
        *ngIf="displayedItems.assistance">
        <ion-label><img src="assets/icons/calendar.svg" alt="menu" /> {{ 'actividades' | translate }}</ion-label>
    </ion-item>

    <ion-item
        (click)="goTo('/workout')"
        [class.selected]="currentUrl === '/workout'"
        [disabled] = "currentUrl === '/workout'"
        *ngIf="displayedItems.workoutGroup">
        <ion-label><img src="assets/icons/user-contact.svg" alt="menu" /> {{ 'rutinas' | translate }}</ion-label>
    </ion-item>

    <ion-item
        (click)="toggleShowCapacity()"
        [class.selected]="currentUrl === '/capacity'"
        [disabled] = "currentUrl === '/capacity'"
        class="has-submenu"
        *ngIf = "displayedItems.capacityControl.displayMenuOption">
        <ion-label><img src="assets/icons/team.svg" alt="menu" /> {{ 'aforo' | translate }}</ion-label>
    </ion-item>

    <ng-container *ngIf="showCapacitySubMenu">
        <ion-item
            (click)="goTo('/capacity/status')"
            [class.selected]="currentUrl === '/capacity/status'"
            [disabled] = "currentUrl === '/capacity/status'"
            class="submenu"
            *ngIf="displayedItems.capacityControl.accessSettings">
            <ion-label>{{ 'control' | translate }}</ion-label>
        </ion-item>

        <ion-item
            (click)="goTo('/capacity/manual')"
            [class.selected]="currentUrl === '/capacity/manual'"
            [disabled] = "currentUrl === '/capacity/manual'"
            class="submenu"
            *ngIf="displayedItems.capacityControl.accessManual">
            <ion-label>{{ 'asistencia_salas' | translate }}</ion-label>
        </ion-item>

        <ion-item
            (click)="goTo('/capacity/automatic')"
            [class.selected]="currentUrl === '/capacity/automatic'"
            [disabled] = "currentUrl === '/capacity/automatic'"
            class="submenu"
            *ngIf="displayedItems.capacityControl.accessControl">
            <ion-label>{{ 'automatic_registry' | translate }}</ion-label>
        </ion-item>
    </ng-container>

    <ng-container *ngIf="devices.length">
        <ion-item
            (click)="openAccessDevice()">
            <ion-label><ion-icon name="exit-outline"></ion-icon> {{ 'open_access_device' | translate }}</ion-label>
        </ion-item>
    </ng-container>
</ion-list>

<ion-popover trigger="right-menu-trigger" triggerAction="click" class="menu-right-popover" alignment="end" arrow="false" dismissOnSelect="true">
    <ng-template>
        <ion-content class="ion-padding">
            <ion-list lines="none">
                <ion-item (click)="updateCenter()" *ngIf="centersList.length > 1">
                    <ion-label><img src="assets/icons/position.svg" alt="menu" /> {{ 'cambiar_centro' | translate }}</ion-label>
                </ion-item>
                <ion-item (click)="updateDesktopView()">
                    <ion-label><img src="assets/icons/expand.svg" alt="menu" /> {{ 'desktop_view' | translate }}</ion-label>
                </ion-item>
                <ion-item (click)="talkToCustomerSupport()" *ngIf="showSupportButton">
                    <ion-label><img src="assets/icons/bell-outline.svg" alt="menu" /> {{ 'soporte' | translate | titlecase }}</ion-label>
                </ion-item>
                <ion-item (click)="logout()">
                    <ion-label><ion-icon name="power-outline"></ion-icon> {{ 'salir' | translate }}</ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ng-template>
</ion-popover>

<app-success-modal [displaySuccessModal]="showSuccessModal" [title]="'access_device_opened' | translate" [description]="'authorized_opening_of' | translate: { device: deviceName }" (closeModal)="onSuccessCloseModal()"></app-success-modal>
<app-error-modal [displayErrorModal]="showErrorModal" [title]="'an_error_has_ocurred' | translate" [description]="'retry_later' | translate" (closeModal)="onErrorCloseModal()"></app-error-modal>